module.exports = __webpack_public_path__ + "static/img/icon_none_prj.42fb305.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_none_prj.png
// module id = vRHR
// module chunks = 167